import React from 'react';

const LatestCollection = () => {

  return (
    <section className="bg-gradient-to-br from-gray-50 via-amber-50 to-orange-50 py-12 md:py-16 lg:py-20 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-br from-amber-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-amber-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-12 max-w-7xl relative z-10">
        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
            {/* Left Column - Text Content */}
            <div className="flex flex-col justify-center space-y-4 sm:space-y-6 md:space-y-8 p-6 sm:p-8 md:p-12 lg:p-16">
              <h2 
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight"
                style={{fontFamily: "'Playfair Display', 'Georgia', serif"}}
              >
                Crafted with Precision & Passion
              </h2>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-700 mb-4">Designed for Modern Interiors</h2>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-700 leading-relaxed max-w-xl">
                Wovn Rugss (wovnrugss.com) — Woven rugs, wovn rugs, wovnrugs, wovenrugs. A curated collection of hand-tufted and hand-knotted rugs, crafted with precision, texture, and timeless design for modern living.
              </p>
              
              <button
                onClick={() => {
                  window.location.href = '#contact';
                }}
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-full font-bold text-sm sm:text-base md:text-lg hover:from-amber-700 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-amber-500/50 self-start sm:self-start w-full sm:w-auto text-center mt-2 sm:mt-4 group"
              >
                <span>Our Latest Catalogue</span>
                <svg className="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </button>
            </div>

            {/* Right Column - Image */}
            <div className="relative h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
              <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
                <img
                  src="/images/latest-collection.png"
                  alt="Luxury handcrafted wool rug for living room by Wovn Rugss – wovnrugss.com"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestCollection;
